import {
  FileCard,
  FullScreen,
  ImagePreview,
  //   createSyntheticFile,
  //   uploadFile,
} from "@files-ui/react";
import { useBulkOCR } from "../context/BulkOCRContext";
import {
  Alert,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  LinearProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import * as React from "react";
import DeleteIcon from "@mui/icons-material/Delete";

function OCRGroupCard({ group, index, submitSuccess }) {
  const { dispatch } = useBulkOCR();
  const [extraImg, setExtraImg] = React.useState([]);
  const [imgSrc, setImgSrc] = React.useState(undefined); // for image preview
  const handleSee = (image) => {
    setImgSrc(image);
  };
  const [openDialog, setOpenDialog] = React.useState(false);

  React.useEffect(() => {
    const convertOCRImages = () => {
      const ocrBlock = group.files?.map((img, i) => {
        let format = img.split(".").pop().toLowerCase();
        let imageSample = {
          id: img,
          type: "image/" + format,
          name: i + "." + format,
          imageUrl: `${process.env.REACT_APP_API_HOST}/v2/image/${img}`,
        };
        return imageSample;
      });
      setExtraImg(ocrBlock);
    };
    if (group?.files) {
      convertOCRImages();
    }
  }, [group]);

  const handleDelete = () => {
    dispatch({ type: "DELETE_GROUP", id: group.id });
    setOpenDialog(false);
  };

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h6" fontWeight={"600"}>
            作文輸入 {index + 1}
          </Typography>
        }
        action={
          <Stack direction="row" alignItems={"center"} spacing={1}>
            <Chip
              size="small"
              label={group?.inputType === "ocr" ? "OCR" : "手動輸入"}
              color={"default"}
            />
            <Chip
              size="small"
              sx={{ display: group?.inputType !== "ocr" ? "none" : "block" }}
              label={
                group?.status === "completed"
                  ? "已完成"
                  : group?.status === "processing"
                  ? "正在轉譯中…"
                  : "排列中"
              }
              color={
                group?.status === "completed"
                  ? "success"
                  : group?.status === "processing"
                  ? "info"
                  : "default"
              }
            />
            {/* Delete button */}
            <IconButton
              aria-label="delete"
              color="error"
              onClick={() => setOpenDialog(true)}
              disabled={
                group?.status === "processing" ||
                group?.status === "queued" ||
                submitSuccess
              }
              sx={{ ml: 1 }}
            >
              <DeleteIcon />
            </IconButton>
          </Stack>
        }
      />
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>
          <Alert severity="warning" sx={{ alignItems: "center" }}>
            刪除
          </Alert>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            你確定要刪除此組作文輸入嗎？此操作無法還原。
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="inherit">
            取消
          </Button>
          <Button onClick={handleDelete} color="error" variant="contained">
            刪除
          </Button>
        </DialogActions>
      </Dialog>
      <>
        <CardContent sx={{ pt: 0 }}>
          <Stack direction="row" spacing={1}>
            {(group?.status === "processing" || group?.status === "queued") && (
              <LinearProgress sx={{ mx: 2, mb: 2 }} />
            )}
            {group?.files?.length > 0 ? (
              <Stack direction="column" spacing={1} sx={{ mt: 2 }}>
                <Grid container direction={"row"} spacing={1}>
                  {extraImg?.map((img, i) => {
                    return (
                      <Grid item key={i}>
                        <FileCard
                          id={i}
                          {...img}
                          onSee={handleSee}
                          //onDelete={handleDelete}
                        />
                        <FullScreen
                          open={imgSrc !== undefined}
                          onClose={() => setImgSrc(undefined)}
                        >
                          <ImagePreview src={imgSrc} />
                        </FullScreen>
                      </Grid>
                    );
                  })}
                </Grid>
              </Stack>
            ) : null}
          </Stack>
        </CardContent>
        {(group?.status === "processing" || group?.status === "queued") && (
          <LinearProgress sx={{ mt: 2, mb: 2 }} />
        )}
        {group?.status === "completed" && (
          <>
            <Typography
              variant="body2"
              fontWeight={"600"}
              sx={{ mb: 1, mt: 2, ml: 1 }}
            >
              請修改作文內容 (請依照原文分段，把多行文字合成一行或一段文字)
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={15}
              disabled={submitSuccess}
              value={group.text}
              label="請修改作文內容"
              sx={{
                mt: 1,
                mb: 2,
                backgroundColor: "#F0F0F0",
                ".MuiInputBase-root": {
                  fontSize: "20px !important",
                  passingBottom: "20px !important",
                },
                ".MuiInput-root": {
                  height: " 20px !important",
                },
              }}
              onChange={(e) =>
                dispatch({
                  type: "SET_TEXT",
                  id: group.id,
                  text: e.target.value,
                  status: "completed",
                })
              }
            />
          </>
        )}
      </>
    </Card>
  );
}
export default OCRGroupCard;
